<template>
  <div class="pagss">
    <div class="bottom-contain">
      <div class="company-name">
        <div class="company-left">深圳市高扬生物科技有限公司</div>
        <div class="company-right">
          友情链接：<a
            href="http://www.gy-service.com.cn/"
            target="_blank"
            rel="nofollow"
          >
            高扬电子
          </a>
          |
          <a href="http://www.spr-atm.com/" target="_blank" rel="nofollow"
            >森普瑞</a
          >
          |
          <!-- <a href="http://www.atm020.com/#/login" target="_blank" rel="nofollow"
            >合作库</a
          >
          | -->
          <a
            href="https://www.gobeyond-atm.com/"
            target="_blank"
            rel="nofollow"
          >
            Gobeyond International
          </a>
          |
          <span>
            <a
              href="https://spr-atm.en.alibaba.com/"
              target="_blank"
              rel="nofollow"
            >
              E - PRODUCTS
            </a>
          </span>
        </div>
      </div>
      <div class="address">
        地址：广东省深圳市宝安区新安街道兴东社区68区留仙三路2号鸿辉工业区2号厂房901A
      </div>
      <div class="information-contain">
        <div class="information">
          <span>邮编：518000</span>
          <span class="message">电话：400-900-9023</span>
          <span class="message">手机：18300049333</span>
          <span class="message">邮箱：atm8125@qh-service.com.cn</span>
        </div>
        <div class="external">
          <!-- <div class="bshare-custom">
            <a title="分享到新浪微博" class="bshare-sinaminiblog"></a>
            <a title="分享到微信" class="bshare-weixin"></a>
            <a title="分享到QQ好友" class="bshare-qqim"></a>
          </div> -->
          <div class="icon" @click="sinaminClick">
            <a
              title="分享到新浪微博"
              target="_blank"
              rel="nofollow"
              href="https://service.weibo.com/share/share.php?appkey=583395093&title=%E6%B7%B1%E5%9C%B3%E5%89%8D%E6%B5%B7%E9%AB%98%E6%89%AC%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%20-%20%20%20&url=http://www.qh-service.com.cn&source=bshare&retcode=0&ralateUid=#_loginLayer_1616462440383"
              ><img src="../../static/images/icon1.png" alt="新浪微博" />
            </a>
          </div>
          <div class="icon">
            <a
              title="分享到QQ好友"
              rel="nofollow"
              href="tencent://message/?uin=2850559846&Site=uemo&Menu=yes"
              ><img src="../../static/images/icon3.png" alt="QQ"
            /></a>
          </div>
          <div class="icon" @click="dialogTableVisible = true">
            <img src="../../static/images/icon2.png" alt="微信" />
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-contain">
      <div class="bottom-copyright">
        Copyright © 深圳市高扬生物科技有限公司
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          rel="nofollow"
        >
          粤ICP备19007655号
        </a>
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502008310"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          ><img src="/static/备案图标.png" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            粤公网安备 44030502008310号
          </p>
        </a>
      </div>
    </div>
    <el-dialog :visible.sync="dialogTableVisible" width="15%">
      <div class="dialogImg">
        <img src="../../static/images/code3.jpg" alt="微信" />
        <div class="dialog-text">微信扫一扫</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogTableVisible: false
    };
  },
  methods: {
    sinaminClick() {
      console.log("微博分享");
    }
  }
};
</script>

<style scoped lang="less">
.pagss {
  width: 100%;
  background: #f9f9f9;
  .bottom-contain {
    width: 1170px;
    margin: 0 auto;
    .company-name {
      width: 100%;
      height: 65px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .company-left {
        color: #444444;
        font-size: 16px;
        font-weight: 300;
      }
      .company-right {
        color: #999999;
        font-size: 12px;
        a:hover {
          color: #444444;
        }
        a {
          border: 0;
          outline: 0;
          vertical-align: baseline;
          text-decoration: none;
          list-style: none;
          color: #999999;
          margin: 0 4px;
        }
        span {
          margin-left: 4px;
          a {
            margin: 0;
          }
        }
      }
    }
  }
  .address {
    color: #999999;
    font-size: 12px;
  }
  .information-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .information {
      color: #999999;
      font-size: 12px;
      margin-top: 6px;
      .message {
        margin-left: 25px;
        span {
          margin-left: 20px;
        }
      }
    }
    .external {
      width: 130px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .icon {
        cursor: pointer;
      }
    }
  }
  .copyright-contain {
    width: 100%;
    height: 40px;
    color: #999999;
    font-size: 12px;
    background: #f9f9f9;
    border-top: 1px solid #eeeeee;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 15px;
    .bottom-copyright {
      width: 1170px;
      margin: 0 auto;
      line-height: 40px;
      a:hover {
        color: #444444;
      }
      a {
        border: 0;
        outline: 0;
        vertical-align: baseline;
        text-decoration: none;
        list-style: none;
        color: #999999;
        margin-left: 4px;
      }
    }
  }
}

.dialogImg {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 258px;
    height: 258px;
    display: inline-block;
  }
  .dialog-text {
    margin-bottom: 15px;
    text-align: center;
    font-size: 14px;
    color: #000;
  }
}
/deep/ .el-dialog__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue